var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.500000, 1.500000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0 C3.3645,0 0,3.3645 0,7.5 C0,11.63625 3.3645,15 7.5,15 C11.6355,15 15,11.63625 15,7.5 C15,3.3645 11.6355,0 7.5,0 Z M6.75,3 L8.25,3 L8.25,8.25 L6.75,8.25 L6.75,3 Z M7.5,11.4375 C6.9825,11.4375 6.5625,11.01825 6.5625,10.5 C6.5625,9.9825 6.9825,9.5625 7.5,9.5625 C8.0175,9.5625 8.4375,9.9825 8.4375,10.5 C8.4375,11.01825 8.0175,11.4375 7.5,11.4375 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.6ffd5f83067159d3587af8d94d36c707.svg";
export { ForwardRef as ReactComponent };